// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main container for aligning left and right side with equal height */
.container {
    display: flex;
    gap: 35px;
    align-items: stretch;
    padding-top: 10px;
}


.container .left-side {
    padding-top: 20px;
    font-size: 1rem;
    flex: 0 0 25%;
    display: flex;
    flex-direction: column;
    justify-content: center;

}

.right-side {
    flex: 1 1; /* Right side takes up the remaining width */
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    /* padding: 20px; */
}

.subtitle {
    font-weight: 600;
    letter-spacing: 1px;
}

.left-side > .subtitle {
    font-size: 1.5rem;
    letter-spacing: -0.5px;
    padding: 20px 0;
    color: #B54708;
}

.right-side .subtitle {
    font-size: 1.5rem;
    padding: 20px 0;
    color: #B54708;

}

.subtitle-row {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    margin-bottom: 16px;
    padding-top: 20px;
}

.edition-cards, .popular {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.viewAll {
    display: flex;
    align-items: center;
}

.subtitle-row .hdivider{
    width: 50%;
}
.hdivider img{
    width: 100%;
}

/* Optional: Adjustments for responsive design */
@media (max-width: 768px) {
    .container {
        flex-direction: column;
    }
    .left-side, .right-side {
        width: 100%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/booksSection/booksSection.css"],"names":[],"mappings":"AAAA,sEAAsE;AACtE;IACI,aAAa;IACb,SAAS;IACT,oBAAoB;IACpB,iBAAiB;AACrB;;;AAGA;IACI,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;;AAE3B;;AAEA;IACI,SAAO,EAAE,4CAA4C;IACrD,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,cAAc;;AAElB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;AACA;IACI,WAAW;AACf;;AAEA,gDAAgD;AAChD;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,WAAW;IACf;AACJ","sourcesContent":["/* Main container for aligning left and right side with equal height */\n.container {\n    display: flex;\n    gap: 35px;\n    align-items: stretch;\n    padding-top: 10px;\n}\n\n\n.container .left-side {\n    padding-top: 20px;\n    font-size: 1rem;\n    flex: 0 0 25%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n\n}\n\n.right-side {\n    flex: 1; /* Right side takes up the remaining width */\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    /* padding: 20px; */\n}\n\n.subtitle {\n    font-weight: 600;\n    letter-spacing: 1px;\n}\n\n.left-side > .subtitle {\n    font-size: 1.5rem;\n    letter-spacing: -0.5px;\n    padding: 20px 0;\n    color: #B54708;\n}\n\n.right-side .subtitle {\n    font-size: 1.5rem;\n    padding: 20px 0;\n    color: #B54708;\n\n}\n\n.subtitle-row {\n    display: flex;\n    align-items: baseline;\n    justify-content: space-between;\n    margin-bottom: 16px;\n    padding-top: 20px;\n}\n\n.edition-cards, .popular {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.viewAll {\n    display: flex;\n    align-items: center;\n}\n\n.subtitle-row .hdivider{\n    width: 50%;\n}\n.hdivider img{\n    width: 100%;\n}\n\n/* Optional: Adjustments for responsive design */\n@media (max-width: 768px) {\n    .container {\n        flex-direction: column;\n    }\n    .left-side, .right-side {\n        width: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
